import { useSelector } from "react-redux";
import { Constant } from "../../constants/constant";
import { commonReducerSelector } from "../../redux/selector";
import { isEmpty } from "lodash";

export function propsToInitialState(
  data,
  loHangList,
  loaiPhanBonList,
  loaiBenhHaiList,
  loaiThuocTruSauList
) {
  const dataInit = { ...data };
  dataInit.loHang = loHangList?.find(x => x?.id === data?.idLoHang) || null;
  dataInit.ngayGieoTrong = data?.ngayGieoTrong || null;
  dataInit.ngayThuHoach = data?.ngayThuHoach || null;

  dataInit.phanBons = (!isEmpty(data?.lsPhanBon) &&
    data?.lsPhanBon?.map(item => ({
      loaiPhanBon: loaiPhanBonList?.find(x => x?.id === item?.idPhanBon),
      ngayDung: item?.ngayDung || null,
      moTa: item?.moTa || null
    }))) || [
    {
      loaiPhanBon: null
    }
  ];

  dataInit.benhHais = (!isEmpty(data?.lsBenhHai) &&
    data?.lsBenhHai?.map(item => ({
      loaiBenhHai: loaiBenhHaiList?.find(x => x?.id === item?.idBenhHai),
      ngayPhatBenh: item?.ngayPhatBenh || null,
      ngayKetThuc: item?.ngayKetThuc || null,
      moTa: item?.moTa || null
    }))) || [
    {
      loaiBenhHai: null
    }
  ];

  dataInit.thuocTruSaus = (!isEmpty(data?.lsThuocTruSau) &&
    data?.lsThuocTruSau?.map(item => ({
      loaiThuocTruSau: loaiThuocTruSauList?.find(
        x => x?.id === item?.idThuocTruSau
      ),
      ngayPhatBenh: item?.ngayPhatBenh || null,
      ngayKetThuc: item?.ngayKetThuc || null,
      moTa: item?.moTa || null
    }))) || [
    {
      loaiThuocTruSau: null
    }
  ];

  return dataInit;
}

export function parseDataSave(value, profile) {
  const dataSave = { ...value };
  dataSave.idLoHang = value?.loHang?.id || 0;
  dataSave.ngayGieoTrong = value?.ngayGieoTrong || 0;
  dataSave.ngayThuHoach = value?.ngayThuHoach || 0;
  dataSave.lsPhanBon = [];
  value?.phanBons?.forEach(item => {
    dataSave.lsPhanBon.push({
      idPhanBon: item?.loaiPhanBon?.id || 0,
      moTa: item?.moTa,
      ngayDung: item?.ngayDung || 0
    });
  });
  dataSave.lsBenhHai = [];
  value?.benhHais?.forEach(item => {
    dataSave.lsBenhHai.push({
      idBenhHai: item?.loaiBenhHai?.id || 0,
      ngayPhatBenh: item?.ngayPhatBenh || 0,
      ngayKetThuc: item?.ngayKetThuc || 0,
      moTa: item?.moTa
    });
  });
  dataSave.lsThuocTruSau = [];
  value?.thuocTruSaus?.forEach(item => {
    dataSave.lsThuocTruSau.push({
      idThuocTruSau: item?.loaiThuocTruSau?.id || 0,
      ngayDung: item?.ngayDung || 0,
      moTa: item?.moTa
    });
  });

  return dataSave;
}
